export function useIsIos() {
  if (window.navigator.userAgent.startsWith("==iOS==")) {
    return true;
  } else {
    return false;
  }
}
